import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  private show(message: string, panelClass: string[], duration: number = 3000) {
    const config: MatSnackBarConfig = {
      duration,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: ['custom-snackbar', ...panelClass]
    };

    this.snackBar.open(message, '✕', config);
  }

  success(message: string, duration: number = 3000) {
    this.show(message, ['snackbar-success'], duration);
  }

  error(message: string, duration: number = 4000) {
    this.show(message, ['snackbar-error'], duration);
  }

  info(message: string, duration: number = 3000) {
    this.show(message, ['snackbar-info'], duration);
  }

  warning(message: string, duration: number = 3000) {
    this.show(message, ['snackbar-warning'], duration);
  }
}
